import React, { Suspense, lazy } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Segment, Sidebar } from 'semantic-ui-react';
import MenuBar from './menu-bar';
import { route } from 'src/app/route';
import { parseNumber } from 'src/utils';
import { HeaderBar } from 'src/components/header-bar';
const EditSaleFinalProduct = lazy(() => import('src/components/sale-final-product/edit-sale-final-product'));

interface IEditSaleFinalProductParams {
  saleFinalProductId?: string;
}

export class EditSaleFinalProductPage extends React.PureComponent<
  RouteComponentProps<IEditSaleFinalProductParams, {}>
> {
  public componentDidMount() {
    document.title = route.getPageTitle(this.props.location.pathname);
  }

  public render() {
    const saleFinalProductId = parseNumber(
      this.props.match.params.saleFinalProductId
    );
    const title = route.getPageTitle(this.props.location.pathname);

    return (
      <Sidebar.Pushable as={Segment} className='x-page'>
        <MenuBar />

        <Sidebar.Pusher>
          <Segment basic={true}>
            <HeaderBar title={title} />

            <Suspense fallback={<div className='x-loading' />}>
              <EditSaleFinalProduct saleFinalProductId={saleFinalProductId} />
            </Suspense>
          </Segment>
        </Sidebar.Pusher>
      </Sidebar.Pushable>
    );
  }
}
